'use strict';

module.exports = [
	'<script type="text/javascript">',
	'  function changeCompanyContext(userId, companyId) {',
	'    document.dispatchEvent(new CustomEvent(\'universalnav:call\', { detail: { widget: \'Header\', method: \'clearStorage\' } }));',
	'    $.ajax({',
	'      url: \'/api/account/v2/users/\' + userId + \'/memberships/\' + companyId + \'/current\',',
	'      type: \'put\'',
	'    }).then(function () {',
	'      window.location = \'/home\';',
	'    });',
	'  }',
	'</script>'
].join('\n');



//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/templates/functions/company-function.tpl.js
// module id = 32
// module chunks = 0